import { Col, ErrorSummary, HorizontalRule, Row, SectionPage } from '@snsw/react-component-library';
import { DeclarationPage } from 'plantItemNew/constants/declarationPage';
import { PlantItemConstants } from 'plantItemNew/constants/plantItemConstants';
import { storeApplicantNames, storeJobTitle } from 'plantItemNew/redux/slices/applicantDetailsSlice';
import { clearDeclaration, storeDeclaration } from 'plantItemNew/redux/slices/declarationSlice';
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Declaration } from 'shared/components/declaration/Declaration';
import { PasswordlessContinueSaveExitButtons } from 'shared/components/formNavigationButtons/PasswordlessContinueSaveExitButtons';
import { PagePath } from 'shared/constants/pagePath';
import { saveApplication } from 'shared/redux/applicationSlice';
import { getFullname, splitFullName } from 'shared/utils/Helpers';
import ScrollToTop from 'shared/utils/scrollToTop';
import { scrollToError } from 'shared/utils/Validation';

export const PlantItemNewDeclaration = () => {
  ScrollToTop();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const applicantState = useSelector((state) => state.applicantDetails);
  const holderState = useSelector((state) => state.holderDetails);
  const declarationState = useSelector((state) => state.declaration);

  const fullName = getFullname(applicantState.firstName, applicantState.middleName, applicantState.lastName);

  const [declarationDetails, setDeclarationDetails] = useState({});
  const [showErrors, setShowErrors] = useState(false);
  const [errorSummary, setErrorSummary] = useState([]);

  const childRef = useRef();

  const warning = {
    title: <>Giving false or misleading information is a serious offence.</>,
    content: (
      <>
        <p>The details you provided in this application must be true and correct.</p>
        <br />
        <p>
          Under the Crimes Act 1900, you could be fined or imprisoned for giving false or misleading information or
          documents.
        </p>
      </>
    ),
  };

  const onContinueClick = () => {
    const isValid = childRef.current.validate();
    setShowErrors(!isValid);
    if (isValid) {
      acceptDeclaration();
      navigate(PagePath.fees);
    } else {
      dispatch(clearDeclaration());
      scrollToError();
    }
  };

  const acceptDeclaration = () => {
    if (!holderState.amIRegistrationHolder) {
      const names = splitFullName(declarationDetails.fullName);
      dispatch(storeApplicantNames(names));
    }
    // dispatch(store(declarationDetails.fullName));
    dispatch(storeJobTitle({ jobTitle: declarationDetails.jobTitle }));
    dispatch(
      storeDeclaration({
        accepted: declarationDetails.accepted,
        stamp: declarationDetails.agreementStampText,
      }),
    );
  };

  return (
    <>
      <SectionPage>
        <Row>
          <Col span={8}>{showErrors && !!errorSummary?.length && <ErrorSummary errors={errorSummary} />}</Col>
        </Row>

        <Declaration
          ref={childRef}
          warning={warning}
          consent={DeclarationPage.consent}
          fullName={fullName}
          isFullNameEditable={!(holderState.amIRegistrationHolder && fullName)}
          jobTitle={applicantState?.jobTitle}
          accepted={declarationState?.accepted}
          onChange={setDeclarationDetails}
          showErrors={showErrors}
          onErrorChange={setErrorSummary}
        />

        <HorizontalRule />

        <PasswordlessContinueSaveExitButtons
          onContinueClick={onContinueClick}
          onPreSaving={() => dispatch(saveApplication(true))}
          onBackClick={() => navigate(PagePath.plantItemList)}
          licenceType={PlantItemConstants.licenceType}
        />
      </SectionPage>
    </>
  );
};
